export default "__VITE_ASSET__BjL418IR__"